export default "__VITE_ASSET__BRSwCoT6__"